import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { colorsPalette, LARGE_MARGIN, MIDDLE_MARGIN, SMALL_MARGIN, TINY_MARGIN } from '../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      '& $headerWrapper': {
        marginBottom: MIDDLE_MARGIN,
        [theme.breakpoints.up('md')]: {
          MIDDLE_MARGIN,
        },
      },
      '& $headerContainer': {
        paddingTop: 130,
        paddingBottom: LARGE_MARGIN,
        [theme.breakpoints.up('md')]: {
          paddingTop: 200,
          paddingBottom: LARGE_MARGIN,
        },
      },
      '& $headerTitle': {
        marginBottom: 0,
        textAlign: 'left',
      },
    },
    headerWrapper: {},
    headerContainer: {},
    headerTitle: {},
    viewSwitcherWrap: {
      position: 'relative',
      paddingBottom: MIDDLE_MARGIN,
      [theme.breakpoints.up('md')]: {
        paddingBottom: 0,
      },
    },
    viewSwitcher: {
      position: 'absolute',
      right: 16,
      top: -18,
      [theme.breakpoints.up('md')]: {
        top: 0,
      },
    },
    managerAnalytics: {
      '& $innerWrapper': {
        marginBottom: LARGE_MARGIN,
      },
    },
    userAnalytics: {
      '& $innerWrapper': {
        marginBottom: MIDDLE_MARGIN,
      },
    },
    container: {
      marginTop: 30,
    },
    innerWrapper: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    smallCardsWrap: {
      width: '100%',
      display: 'flex',
      flexWrap: 'wrap',
      order: 1,

      '& $card': {
        marginBottom: SMALL_MARGIN,
        width: '100%',
      },

      '& $card:last-child': {
        marginBottom: 0,
      },

      [theme.breakpoints.up('md')]: {
        width: '50%',
        marginRight: -15,
        marginBottom: -15,

        '& $card': {
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          marginRight: 15,
          marginBottom: 15,
          width: 'calc(50% - 15px)',
          height: 159.5,
        },

        '& $card:last-child': {
          marginBottom: 15,
        },
      },
    },
    card: {},
    cardNumber: {
      fontSize: 32,
      lineHeight: 1,
      fontWeight: 'bold',
      color: colorsPalette.white,

      '& + $chartWrapper': {
        marginTop: 10,
      },

      '& span': {
        fontSize: 22,
      },

      [theme.breakpoints.up('md')]: {
        fontSize: 43,

        '& + $chartWrapper': {
          marginTop: 0,
        },

        '& span': {
          fontSize: 25,
        },
      },
    },
    chartWrapper: {
      width: '100%',
      height: 140,

      [theme.breakpoints.up('md')]: {
        height: 70,
      },
    },
    radarCard: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      color: colorsPalette.black,
      order: 0,
      marginBottom: SMALL_MARGIN,

      '& $chartWrapper': {
        height: 190,
        marginTop: 0,
      },
      '& > div:first-child': {
        marginBottom: TINY_MARGIN,
        [theme.breakpoints.up('md')]: {
          marginBottom: SMALL_MARGIN,
        },
      },

      [theme.breakpoints.up('md')]: {
        width: '50%',
        marginLeft: 15,
        height: 334,
        paddingBottom: 'unset',
        marginBottom: 0,
        order: 1,
      },
    },
    radarWrapper: {
      width: '100%',
      height: '100%',

      [theme.breakpoints.up('md')]: {
        height: 258,
      },
    },
    tableWrapper: {
      color: colorsPalette.white,
      marginBottom: MIDDLE_MARGIN,
    },
    tableInnerWrap: {
      display: 'flex',
      flexDirection: 'column',
    },
    tableList: {
      width: '100%',
      marginTop: 20,
      marginBottom: 0,
      paddingLeft: 0,

      [theme.breakpoints.up('md')]: {
        display: 'table',
      },
    },
    tableItem: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      color: colorsPalette.grayThird,
      paddingBottom: 44,
      marginBottom: 24,
      borderBottom: `2px solid ${colorsPalette.blueDark}`,

      '&:last-child': {
        paddingBottom: 24,
        borderBottom: 'none',
      },

      [theme.breakpoints.up('md')]: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: 13,
        paddingBottom: 0,
        borderBottom: 'none',

        '&:last-child': {
          paddingBottom: 0,
        },
      },
    },
    tableEmptyState: {
      fontSize: 16,
      marginTop: 24,

      '& a': {
        color: colorsPalette.blue,
      },
    },
    selectWrapper: {
      display: 'flex',

      '& .MuiSelect-icon': {
        color: colorsPalette.turquoiseLight,
      },

      '& .MuiInput-underline:before': {
        borderColor: colorsPalette.turquoiseLight,
      },
    },

    select: {
      textAlign: 'right',
      textTransform: 'uppercase',
      fontSize: 18,
      fontWeight: 'bold',
      color: colorsPalette.turquoiseLight,

      '&:focus': {
        backgroundColor: 'transparent',
      },
    },
    menu: {
      minWidth: 180,
      fontSize: '21px !important',
      fontWeight: 'bold',
      textAlign: 'right',
      textTransform: 'uppercase',
      background: colorsPalette.violetDark,
    },
    desktop: {
      display: 'none',

      [theme.breakpoints.up('md')]: {
        display: 'block',
      },
    },
    chosenBlock: {},
    chosenTitle: {
      fontSize: 22,
      fontWeight: 'bold',
      lineHeight: '22px',
      marginTop: 0,
      marginBottom: SMALL_MARGIN,
    },
    chosenDescription: {
      fontSize: 18,
      fontWeight: 'normal',
      lineHeight: 1.5,
      marginTop: 0,
      marginBottom: MIDDLE_MARGIN,
      color: colorsPalette.gray,
    },
    chosenGraphWrap: {
      position: 'relative',
      height: 400,
    },
    filtersWrapper: {
      display: 'inline-flex',
      alignItems: 'center',
      marginBottom: MIDDLE_MARGIN,
      borderRadius: '999em',
      background: colorsPalette.violetAnalyticsCard,
      justifyContent: 'space-around',
      width: '100%',
      padding: '5px 15px',
      position: 'relative',
      [theme.breakpoints.up('md')]: {
        width: 'auto',
        padding: '5px 35px',
      },
    },
    selectFiltersWrapper: {
      display: 'inline-flex',
      alignItems: 'center',
      marginBottom: MIDDLE_MARGIN,
      borderRadius: '999em',
      background: colorsPalette.violetAnalyticsCard,
      justifyContent: 'space-around',
      padding: '5px 15px',

      [theme.breakpoints.up('md')]: {
        width: 'auto',
        padding: '5px 35px',
      },
    },
    filter: {
      marginRight: 10,
      maxWidth: 250,

      '& .MuiSvgIcon-root': {
        color: theme.palette.primary.main,
      },

      '&:hover:before': {
        border: 'none !important',
      },

      '&:before': {
        border: 'none',
      },

      '&:after': {
        border: 'none',
      },

      '&:last-child': {
        marginRight: 0,
      },

      [theme.breakpoints.up('md')]: {
        marginRight: 35,
        fontSize: 18,
      },
    },
    tableWrap: {
      marginTop: SMALL_MARGIN,
      position: 'relative',
    },
    tabMargin: {
      marginTop: SMALL_MARGIN,
      [theme.breakpoints.up('md')]: {
        marginTop: MIDDLE_MARGIN,
      },
      '&:only-child': {
        '& $tableItem:last-child': {
          marginBottom: 0,
        },
      },
    },
    progressBarWrapper: {
      width: 70,
    },
    accordionBtn: {
      marginTop: 12,
      [theme.breakpoints.up('md')]: {
        marginTop: 23,
      },
    },
    rotateWrapper: {
      marginBottom: 60,
    },
    loaderWrapper: {
      width: '100%',
      height: 300,
      position: 'relative',
    },
    anchor: {
      position: 'absolute',
      top: -100,
    },
    headerDescription: {
      marginTop: SMALL_MARGIN,
      color: colorsPalette.gray,
      lineHeight: 1.5,
      fontSize: 18,
      maxWidth: 620,
      [theme.breakpoints.up('md')]: {
        fontSize: 20,
        marginTop: MIDDLE_MARGIN,
      },
    },
    greenLabel: {
      color: colorsPalette.green,
    },
    grayLabel: {
      color: colorsPalette.gray,
    },
  }),
);

export default useStyles;
